import React from 'react';
import { AppDispatch } from 'reducers/index';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { LightBulb2 } from '@zola/zola-ui/src/assets/images/icons';
import { isMobile } from 'lib/responsive';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

export type DigitalOnCopyLinkProps = {
  onConfirm: () => void;
};

const DigitalOnCopyLink = (props: DigitalOnCopyLinkProps): JSX.Element => (
  <div className={styles.digitalTipsContainer}>
    <CircleIcon image={LightBulb2} size={100} variant="cream" />
    <div className={styles.header}>Copied and ready for you to paste</div>
    <div className={styles.content}>
      <ol className={styles.digitalTipsList}>
        <li>Start a new text, DM, or email</li>
        <li>Proof the message you want to send to guests</li>
        <li>Paste in this URL</li>
        <li>Send</li>
      </ol>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={props.onConfirm} fullWidth={isMobile()}>
        Got It
      </ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalOnCopyLink);
